export const ru = {
    dayBudgetMode: 'Режим показа',
    perDay: 'в день'
};
